export const Work = [
  {
    id: 1,
    name: "SitePilot",
    description:
      "An AI-powered, multi-tenant SaaS platform that automates website creation, management, and optimization at scale with strong tenant isolation and modular backend services.",
    tags: ["Next.js", "Node.js", "AI/LLMs", "Multi-Tenant", "Cloud"],
    demo: "https://github.com/JayeshWani7/SitePilot",
    github: "https://github.com/JayeshWani7/SitePilot",
  },
  {
    id: 2,
    name: "Chronos",
    description:
      "A Selenium/CDP-based browser state version control & time-travel debugger that captures DOM mutations, network, and console state into a queryable Git-inspired format.",
    tags: ["Java", "Selenium", "CDP", "SQLite", "LZ4"],
    demo: "https://github.com/JayeshWani7/chronos",
    github: "https://github.com/JayeshWani7/chronos",
  },
  {
    id: 3,
    name: "Netra AI",
    description:
      "A WPF desktop AI assistant delivering low-latency LLM features with secure Firebase authentication and modular services (Auth, Permissions, ChatHistory, Gemini, ScreenCapture).",
    tags: ["C#", ".NET", "WPF", "Firebase", "LLMs"],
    demo: "https://github.com/JayeshWani7/Netra-AI",
    github: "https://github.com/JayeshWani7/Netra-AI",
  },
  {
    id: 4,
    name: "Code-Craft",
    description:
      "A collaborative code-sharing and interview preparation platform where users can create, edit, and share code snippets in real-time with syntax highlighting and markdown support.",
    tags: ["React", "Firebase", "Tailwind", "CodeMirror"],
    demo: "https://code-craft-seven.vercel.app/",
    github: "https://github.com/JayeshWani7/Code-Craft",
  },
  {
    id: 5,
    name: "DSABUDDY",
    description:
      "A React-based web application that serves as a DSA visualizer and problem-solving assistant, enhancing learning and understanding of data structures and algorithms.",
    tags: ["react", "DSA", "visualization"],
    demo: "https://dsabuddy-eta.vercel.app/",
    github: "https://github.com/JayeshWani7/DSABUDDY",
  },
  {
    id: 6,
    name: "Sacred Heart School Website",
    description:
      "A responsive school website designed with modern UI/UX principles to showcase academic information, gallery, contact forms, and announcements.",
    tags: ["Astro", "TypeScript", "Express", "Tailwind"],
    demo: "https://sacred-heart-school.vercel.app/",
    github: "https://github.com/JayeshWani7/Sacred-Heart-School",
  },
  {
    id: 7,
    name: "Shared Commenting App",
    description:
      "A full-stack NestJS + React application that supports user authentication, nested commenting, edit/delete/restore functionality, and Dockerized deployment.",
    tags: ["NestJS", "React", "PostgreSQL", "Docker"],
    demo: "https://shared-commenting-app.vercel.app/",
    github: "https://github.com/JayeshWani7/Shared-Commenting-App",
  },
  {
    id: 8,
    name: "Shared Wishlist App",
    description:
      "A collaborative wishlist application built with Supabase and React, allowing users to create, share, and manage wishlists with real-time updates.",
    tags: ["React", "Supabase", "Realtime", "Tailwind"],
    demo: "https://shared-wishlist-app.vercel.app/",
    github: "https://github.com/JayeshWani7/Shared-Wishlist-App",
  },
  {
    id: 9,
    name: "Electronics Gadgets Website",
    description:
      "A website with an admin panel and gadgets repairing features, built using PHP and MySQL for efficient management and customer service.",
    tags: ["PHP", "MySQL", "admin panel"],
    demo: "",
    github: "https://github.com/JayeshWani7/Electronic-Gadgets",
  },
];
